<template>
  <section class="comment-sort">
    <div class="c-filter-bar">
      <div class="c-filter-bar__sort">
        <label class="c-filter-bar__label" for="sort_by">Sort by</label>
        <div class="c-filter-bar__control">
          <select name="sort_by" id="sort_by" ref="select" v-model="sortBy" tabindex="0">
            <!-- <option value="0" selected>Select</option> -->
            <option v-for="(option, key) in sortOptions" :value="option" :key="key">{{option.label}}</option>
          </select>

          <span class="c-filter-bar__dropdown u-hide-mobile">
            <icon name="drop-arrow" width="8" height="8"></icon>
          </span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    allowVoting: {
      type: [Boolean, Number],
      default: true
    }
  },

  computed: {
    sortOptions() {
      let options = [
        { label: "Newest first", field: "id", direction: "desc" },
        { label: "Oldest first", field: "id", direction: "asc" }
      ];

      if (this.allowVoting) {
        options.unshift({
          label: "Most votes",
          field: "vote_count",
          direction: "desc"
        });
      }

      return options;
    },
    // TODO: Move to store
    sortBy: {
      get() {
        return this.sortOptions[0];
      },
      set(val) {
        this.$emit("onSortChange", val);
      }
    }
  }
};
</script>

<style lang="scss">
.comment-sort {
  .c-filter-bar {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-end;
    align-items: center;

    > div {
      border: 1px solid $colour-nhs-pale-grey;
      height: 54px;

      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    &__label,
    &__control {
      position: relative;
      height: 54px;
      display: flex;
      position: relative;
    }

    &__label {
      padding: 2px 0.65em;
      overflow: hidden;
      min-width: 80px;
      font-size: 16px;
      align-items: center;
      cursor: pointer;
    }

    &__control {
      
      padding-right: 2em;
      min-width: 100px;
      padding: 2px 0 2px 0.5em;

      border-left: 1px solid $colour-nhs-pale-grey;
    }

    @media screen and (min-width: 1024px) {
      > div {
        border-radius: 2em;
        margin-right: 0.5em;
      }

      &__control {
        display: flex;
      }
    }
  }
  .c-filter-bar__sort {
    overflow: hidden;
    margin-right: 0;

    .c-filter-bar__control {
      margin-left: 0;
      padding-left: 0;
      margin-right: 0;
    }
    select {
      // reset
      margin: 0;
      padding: 0;
      border: none;
      background: none;
      outline: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      -ms-appearance: none;
      -o-appearance: none;
      appearance: none;
      width: auto;
      padding-left: 0.5em;
      padding-right: 3em;
      cursor: pointer;
    }
  }
  .c-filter-bar__control {
    cursor: pointer;
    position: relative;
  }
  .c-filter-bar__dropdown {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 3em;
    pointer-events: none;

    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
